module.exports = __webpack_public_path__ + "img/momo_pay_logo.1f3626ca.png";